var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['root' ].concat( _vm.cssClasses),style:(Object.assign({}, _vm.dynamicStyles,
    _vm.bgImageStyle,
    _vm.mediaQueryStyles))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }